module.exports = __webpack_public_path__ + "img/db-reload.91d8247e.svg";